import { Toaster as Sonner, toast } from "sonner"

const Toaster = ({
  ...props
}) => {
  return (
    <Sonner
      theme="light"
      closeButton
      duration={4000}
      gap={8}
      {...props} />
  );
}

export { Toaster, toast }
